import { AppLayout } from 'layouts';
import type { GroupDetail } from 'models';
import type { ReactNode } from 'react';
import { useGroupDetailQuery } from '../queries';
import { GroupLayoutSkeleton } from './group-layout-skeleton';

type P = {
  children: (group: GroupDetail) => ReactNode;
  groupId: string;
  header?: (group: GroupDetail) => ReactNode;
};

const GroupLayout = ({ children, groupId, header }: P) => {
  const { data: group, error } = useGroupDetailQuery({ groupId });

  return (
    <AppLayout error={error}>
      {group ? (
        <>
          {header?.(group)}
          {children(group)}
        </>
      ) : (
        <GroupLayoutSkeleton view={header ? 'detail' : 'list'} />
      )}
    </AppLayout>
  );
};

export default GroupLayout;
